import createSvgIcon from '../Utils/CreateSvgIcon';

export const Avatar = createSvgIcon(
  <path
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-8 8c0-4 3.6-7 8-7s8 3 8 7"
  />,
  'Avatar',
);
